var _polygon, _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialDistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 38.065 33.25 42 34.75 42 34.75 40.783 55.25 40.783 55.25 42 56.75 42 56.75 38.065 55.25 38.065 55.25 39.283 34.75 39.283 34.75 38.065 33.25 38.065"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75,19A5.75,5.75,0,1,0,20,24.75,5.75639,5.75639,0,0,0,25.75,19Zm-10,0A4.25,4.25,0,1,1,20,23.25,4.25475,4.25475,0,0,1,15.75,19Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 52,
    width: 1.5,
    height: 18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,32V48A2.7528,2.7528,0,0,0,12,50.75h1.25V70h1.5V50a.7502.7502,0,0,0-.75-.75H12A1.25116,1.25116,0,0,1,10.75,48V32A3.25377,3.25377,0,0,1,14,28.75H26A3.25377,3.25377,0,0,1,29.25,32V48A1.25116,1.25116,0,0,1,28,49.25H26a.7502.7502,0,0,0-.75.75V70h1.5V50.75H28A2.7528,2.7528,0,0,0,30.75,48V32A4.7554,4.7554,0,0,0,26,27.25H14A4.7554,4.7554,0,0,0,9.25,32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.75,28A2.75,2.75,0,1,0,65,30.75,2.7528,2.7528,0,0,0,67.75,28Zm-4,0A1.25,1.25,0,1,1,65,29.25,1.25116,1.25116,0,0,1,63.75,28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68,33.25H62A2.7528,2.7528,0,0,0,59.25,36v7A1.75213,1.75213,0,0,0,61,44.75h.25V54h1.5V44a.7502.7502,0,0,0-.75-.75H61a.25048.25048,0,0,1-.25-.25V36A1.25116,1.25116,0,0,1,62,34.75h6A1.25116,1.25116,0,0,1,69.25,36v7a.25048.25048,0,0,1-.25.25H68a.7502.7502,0,0,0-.75.75V54h1.5V44.75H69A1.75213,1.75213,0,0,0,70.75,43V36A2.7528,2.7528,0,0,0,68,33.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialDistance);
export default __webpack_public_path__ + "static/media/icon_social_distance.ffd20c29afeb3b2477d7ae19793878b6.svg";
export { ForwardRef as ReactComponent };